import React from 'react'
import styles from './Nav.module.css'

export default function Nav(props) {
  return (
    <nav {...props} className={[styles.nav, props.className]} />
  )
}
